import React from 'react'
import ResultItem from '../result/ResultItem'

const PackResultCreated = ({ result, orderIdCrm }) => {
  return (
    <div className='packResultBlock'>
        <p className='packResultBlock__text'>Успішно створено партію</p>
        <div className='packResultBlock__list'>
            <ResultItem
                text='Замовлення в CRM №: '
                value={orderIdCrm}
            />
            <ResultItem 
                text='Кількість партій, шт: '
                value={result.packs ? result.packs.length : ''}
            />
        </div>
    </div>
  )
}

export default PackResultCreated